$(document).ready(function(){
  	let validation = function() {
      
      var smac 	= $(this).parent("form").find(".loyalty_card").val();
      var data 	= smac.replace(/\D/g,'');
      var counter = data.length;

      if (smac != '')
      {
          if (isNaN(parseInt(smac))) {
            alert("Invalid Card Number");
			return false;
          }

          if(counter === 16)
          {
              cardnumber = data.substring(0,8);
              cardnumber2 = data.substring(0,7);

              var myObj = {
                  "88800010" : "Prestige Nominated By MCI",
                  "88800020" : "Prestige Promoted",
                  "88800030" : "Prestige Nominated By Partner",
                  "88801000" : "Primo Corporate",
                  "88802000" : "Primo Individual",
                  "88801888" : "Toy Kingdom Amazing Card",
                  "88805120" : "BDO Master Card",
                  "88805128" : "BDO Rewards Card",
                  "8880877" : "SM Advantage",
                  "88808885" : "SMAC Employee and Complimentary",
                  "88805200" : "China Bank - SMAC",
                  "88805210" : "China Bank - Prestige"
              };

              if (cardnumber in myObj || cardnumber2 == '8880877') {
                  //$(this).closest('form').trigger('submit');
              } 

              else 
              {
                  alert("Invalid Card Number");
                  return false;
              }

          } else {
              alert("Invalid Card Number");
              return false;
          }
      }
      
    };
  
  
    
    $("#form").on('click', validation);  
  	$(".form-submit").on('click', validation); 
  
  
  });